// Mirror of src/lib/size-class.ts for the native app.
export const SIZE_SPLIT_BREEDS = new Set<string>([
  "All American Dog",
  "American Eskimo Dog",
  "Beagle",
  "Dachshund",
  "Manchester Terrier",
  "Peruvian Inca Orchid",
  "Poodle",
  "Portuguese Podengo",
  "Rat Terrier",
  "Xoloitzcuintli",
]);

export type SizeClass = "below_12" | "12_to_18" | "18_plus";

export const SIZE_CLASSES: SizeClass[] = ["below_12", "12_to_18", "18_plus"];

export const SIZE_LABEL: Record<SizeClass, string> = {
  below_12: 'Below 12"',
  "12_to_18": '12"–18"',
  "18_plus": '18"+',
};

export function hasSizeSplit(breed: string): boolean {
  return SIZE_SPLIT_BREEDS.has(breed);
}

export function heightToSizeClass(heightInches: number | string | null | undefined): SizeClass | null {
  if (heightInches === null || heightInches === undefined) return null;
  const h = typeof heightInches === "string" ? parseFloat(heightInches) : heightInches;
  if (isNaN(h) || h <= 0) return null;
  if (h < 12) return "below_12";
  if (h < 18) return "12_to_18";
  return "18_plus";
}
